import { ReactComponent as TickIcon } from "../icons/lockIcon.svg";

import "./ticks.scss";

export const PrivateTick = () => {
  return (
    <div className="private rg-tick" title="This thing is private">
      <TickIcon />
    </div>
  );
};
